import { FC, JSX, SVGProps, useMemo } from 'react';

import { Hint } from '@semcore/ui/tooltip';

import { useTheme } from '@/features/theme-switch';
import Button from '@/shared/ui/button';

interface IToggleButtonProps {
  Icon: FC<SVGProps<SVGSVGElement>>;
  className?: string;
  tooltip?: string;
  active?: boolean;
  onChange?: (value: boolean) => void;
}

const ToggleButton: FC<IToggleButtonProps> = ({
  Icon,
  className = '',
  tooltip = '',
  active = false,
  onChange,
}): JSX.Element => {
  const { darkTheme = false } = useTheme();
  const btnClassName = useMemo(
    () =>
      `${className} !h-14 !w-14 !items-center !justify-center !rounded-lg p-4 ${active ? 'bg-black dark:bg-blue' : 'border border-black/[.16] dark:bg-black'}`,
    [active, className]
  );

  const iconColor = active || darkTheme ? 'white' : 'black';

  return (
    <Hint placement="top" title={tooltip}>
      <Button
        variant="function"
        size="xl"
        className={btnClassName}
        onClick={() => onChange?.(!active)}
        title={<Icon style={{ color: iconColor }} />}
      />
    </Hint>
  );
};

export default ToggleButton;
